import React from 'react';
import * as S from './styles';

const InputTextarea = React.forwardRef(
  (
    {
      form = undefined,
      name,
      required = false,
      placeholder,
      minLength,
      maxLength,
      label,
      error,
      readonly = false,
      onChange,
      rows = 10,
      ...rest
    },
    ref,
  ) => {
    return (
      <S.InputText>
        <S.Label htmlFor={name}>{label}</S.Label>
        <S.InputContainer>
          <S.Textarea
            ref={ref}
            form={form}
            id={name}
            name={name}
            required={required}
            onChange={onChange}
            minLength={minLength}
            maxLength={maxLength}
            readOnly={readonly}
            placeholder=" "
            rows={rows}
            {...rest}
          />
          <S.PlaceholderWrapper>
            <S.Placeholder>{placeholder}</S.Placeholder>
          </S.PlaceholderWrapper>
          {error && <S.Error>{error}</S.Error>}
        </S.InputContainer>
      </S.InputText>
    );
  },
);

InputTextarea.displayName = 'InputTextarea';

export default InputTextarea;
